
import { defineComponent, PropType } from "vue";
import { RouteLocationMatched } from 'vue-router'
export default defineComponent({
  name: "BreadCrumb",
  props: {
    breadCrumbInfo: {
      type: Array as PropType<RouteLocationMatched[]>,
      default: () => []
    }
  },
  setup() {
    return {};
  }
});
